"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleAsyncCallbacks = exports.Polling = exports.WebSockets = void 0;
var web_ui_framework_1 = require("@gruposantander/web-ui-framework");
Object.defineProperty(exports, "WebSockets", { enumerable: true, get: function () { return web_ui_framework_1.WebSockets; } });
Object.defineProperty(exports, "Polling", { enumerable: true, get: function () { return web_ui_framework_1.Polling; } });
Object.defineProperty(exports, "SimpleAsyncCallbacks", { enumerable: true, get: function () { return web_ui_framework_1.SimpleAsyncCallbacks; } });
//# sourceMappingURL=index.js.map